import React from "react";
import { Text, useColorModeValue } from "@chakra-ui/react";

const PALETTE_LIGHT = [
  { bg: "rgba(52,211,153,0.14)",  border: "rgba(52,211,153,0.32)",  fg: "#047857" }, // emerald
  { bg: "rgba(56,189,248,0.16)",  border: "rgba(56,189,248,0.34)",  fg: "#0369a1" }, // sky
  { bg: "rgba(167,139,250,0.18)", border: "rgba(167,139,250,0.36)", fg: "#6d28d9" }, // violet
  { bg: "rgba(251,113,133,0.16)", border: "rgba(251,113,133,0.34)", fg: "#be123c" }, // rose
  { bg: "rgba(251,191,36,0.18)",  border: "rgba(251,191,36,0.38)",  fg: "#92400e" }, // amber
  { bg: "rgba(45,212,191,0.16)",  border: "rgba(45,212,191,0.34)",  fg: "#0f766e" }, // teal
  { bg: "rgba(129,140,248,0.18)", border: "rgba(129,140,248,0.36)", fg: "#4338ca" }, // indigo
  { bg: "rgba(244,114,182,0.16)", border: "rgba(244,114,182,0.34)", fg: "#a21caf" }, // fuchsia
];

const PALETTE_DARK = [
  { bg: "rgba(52,211,153,0.18)",  border: "rgba(52,211,153,0.38)",  fg: "#6ee7b7" },
  { bg: "rgba(56,189,248,0.18)",  border: "rgba(56,189,248,0.38)",  fg: "#7dd3fc" },
  { bg: "rgba(167,139,250,0.22)", border: "rgba(167,139,250,0.4)",  fg: "#c4b5fd" },
  { bg: "rgba(251,113,133,0.18)", border: "rgba(251,113,133,0.38)", fg: "#fda4af" },
  { bg: "rgba(251,191,36,0.2)",   border: "rgba(251,191,36,0.42)",  fg: "#fcd34d" },
  { bg: "rgba(45,212,191,0.18)",  border: "rgba(45,212,191,0.38)",  fg: "#5eead4" },
  { bg: "rgba(129,140,248,0.22)", border: "rgba(129,140,248,0.4)",  fg: "#a5b4fc" },
  { bg: "rgba(244,114,182,0.18)", border: "rgba(244,114,182,0.38)", fg: "#f0abfc" },
];

function hashIndex(str, modulo) {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = (h * 31 + str.charCodeAt(i)) | 0;
  }
  return Math.abs(h) % modulo;
}

const ProfileDetailsInterestBadge = ({ interest }) => {
  const label = interest.interestName ?? interest.name ?? "";
  const palette = useColorModeValue(PALETTE_LIGHT, PALETTE_DARK);
  const tone = palette[hashIndex(label, palette.length)];

  return (
    <Text
      as="span"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      px={2.5}
      py={1}
      rounded="full"
      fontSize="11px"
      fontWeight="semibold"
      lineHeight="1.4"
      bg={tone.bg}
      borderWidth="1px"
      borderColor={tone.border}
      color={tone.fg}
      textAlign="center"
      noOfLines={1}
      maxW="100%"
    >
      {label}
    </Text>
  );
};

export default ProfileDetailsInterestBadge;
